import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';

type AlertBadgeVariant = 'blacklist' | 'hotlist' | 'vehicle-alert' | 'neutral';

@Component({
    selector: 'app-alert-type-badge',
    standalone: true,
    imports: [CommonModule],
    template: `
        <span *ngIf="label" class="alert-type-badge" [ngClass]="variant">{{ displayLabel }}</span>
    `,
    styles: [`
        .alert-type-badge {
            display: inline-flex;
            align-items: center;
            padding: 0.2rem 0.55rem;
            border-radius: 999px;
            font-size: 0.72rem;
            font-weight: 700;
            letter-spacing: 0.04em;
            text-transform: uppercase;
            line-height: 1.2;
            white-space: nowrap;
        }

        .alert-type-badge.blacklist {
            background: #FEE2E2;
            color: #DC2626;
        }

        .alert-type-badge.hotlist {
            background: #DCFCE7;
            color: #16A34A;
        }

        .alert-type-badge.vehicle-alert {
            background: #FEF3C7;
            color: #D97706;
        }

        .alert-type-badge.neutral {
            background: #E5E7EB;
            color: #374151;
        }
    `]
})
export class AlertTypeBadgeComponent {
    @Input() alertType: string | null | undefined = '';

    get label(): string {
        return (this.alertType || '').trim();
    }

    get displayLabel(): string {
        const normalized = this.label.toUpperCase();
        if (normalized === 'BLOCKLIST') {
            return 'BLACKLIST';
        }
        if (normalized === 'VEH_ALERT') {
            return 'Vehicle Monitoring';
        }
        return normalized;
    }

    get variant(): AlertBadgeVariant {
        const normalized = this.label.toUpperCase();
        if (normalized === 'BLOCKLIST' || normalized === 'BLACKLIST') {
            return 'blacklist';
        }
        if (normalized === 'HOTLIST') {
            return 'hotlist';
        }
        if (normalized === 'VEH_ALERT') {
            return 'vehicle-alert';
        }
        return 'neutral';
    }
}
